<template>
  <div>
    <div class="home" style="display: flex; flex-wrap: wrap">
      <!-- :on-preview="handlePictureCardPreview" -->
      <el-upload
        class="upload-demo"
        :action="url || ''"
        :data="extraData"
        :before-upload="beforeUpload"
        :on-progress="progressUpload"
        :on-success="successUpload"
        :on-remove="handleRemove"
        :on-exceed="exceed"
        :show-file-list="showList"
        :limit="limit"
        :list-type="listType"
        :multiple="multiple"
        :drag="drag"
      >
        <!-- :disabled="" -->
        <i
          class="el-icon-plus"
          style="
            font-size: 28px;
            color: #8c939d;
            position: absolute;
            left: 35%;
            top: 35%;
          "
        ></i>
        <!-- <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div> -->
      </el-upload>
      <div style="display: flex; flex-wrap: wrap">
        <div
          v-for="(item, ind) in imageUrls"
          :key="ind"
          class="child"
          style="
            margin-right: 20px;
            width: 80px;
            height: 80px;
            position: relative;
            border-radius: 6px;
          "
          v-show="imageUrls.length !== 0"
        >
          <imageComponent
            :imageUrls="imageUrls"
            :url="item"
            :ind="ind"
          ></imageComponent>
        </div>
      </div>

      <slot name="img"></slot>
      <slot name="video"></slot>
    </div>
    <div
      class="el-upload__tip"
      slot="tip"
      v-html="text"
      style="margin-top: -20px"
    ></div>
  </div>
</template>

<script>
import crypto from "crypto";
// import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import imageComponent from "./image-component.vue";

function get_suffix(filename) {
  const pos = filename.lastIndexOf(".");
  let suffix = "";
  if (pos != 1) {
    suffix = filename.substring(pos);
  }
  return suffix;
}

export default {
  components: { imageComponent },
  props: {
    //上传限制
    limit: {
      type: Number,
      default: 1,
    },
    //是否显示已上传文件列表
    showList: {
      type: Boolean,
      default: false,
    },
    // //请求头URL地址
    // action: {
    //   type: String,
    //   default: "",
    // },
    //接受的类型
    // accept: {
    //   type: String,
    //   default: "",
    // },
    //组件展示的样式
    listType: {
      type: String,
      default: "picture-card",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: false,
    },
    //多个上传框请上传标识
    // classify: {
    //   type: Number,
    //   default: 1,
    // },
    //接收父组件v-model绑定的值
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      alitoken: {}, //请求ali回来的数据
      extraData: {
        key: "", //文件名
        policy: "", //策略
        success_action_status: "200", //让服务端返回200,不然，默认会返回204
        signature: "", //签名
      },
      imageUrls: [], //图片回显地址
      dialogVisible: false,
      url: "https://zhongtai-admin.oss-cn-hangzhou.aliyuncs.com", //action绑定的地址
      type: 0,
      srcShow: false,
      showViewer: false,
      text: "最多支持5张图片；大小：<30M；格式：PNG,JPG> ", //文字提示
      fadeShow: false,
      fileArr: [], //判断是否多个上传的字段
      limits:0
    };
  },
  watch: {
    value: {
      handler: function (val) {
        this.imageUrls = val;
      },
      deep: true,
      immediate: true,
    },
    limit:{
      handler:function(val){
        this.limits = val
      },
      deep:true,
      immediate:true
    }
    // classify: {
    //   handler: function (val) {
    //     this.type = val;
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  methods: {
    //上传前置校验(图片)
    async beforeUpload(file) {
      //前置校验是否超过限制长度(主要针对回传的数据)
      if(this.limit){
        if(this.limits == this.imageUrls.length){
         return this.exceed()
        }
      }
      //推送字段
      this.fileArr.push(file.name);
      let index = file.name.lastIndexOf(".");
      let extension = file.name.substr(index + 1);
      let extensionList = [
        "png",
        "PNG",
        "jpg",
        "JPG",
        "jpeg",
        "JPEG",
        "bmp",
        "BMP",
      ];
      let isLt2M = file.size / 1024 / 1024 < 30;
      if (!isLt2M) {
        this.$message.warning("图片不能超出30M");
        return false;
      } else if (extensionList.indexOf(extension) < 0) {
        this.$message.error("当前文件格式不支持");
        return false;
      }

      //阿里云签名直传,需要参数policy,OSSAccessKeyId,signature,key(文件名)-----(上传前必带参数头,:data="extraData")
      try {
        let res = await this.$http.post("/System/get_upload_token");
        let { policy, access_key_id, signature, path } = res[1];
        const md5 = crypto.createHash("md5");
        const nameHash = md5
          .update(file.name.split(".")[0] + new Date().getTime().toString())
          .digest("hex");
        this.extraData.key = path + nameHash + get_suffix(file.name);
        this.extraData.policy = policy;
        this.extraData.OSSAccessKeyId = access_key_id;
        this.extraData.signature = signature;
        return true;
      } catch (err) {
        this.$message.error(err);
        return false;
      }
    },
    async progressUpload(file, fileList) {
      console.log(file, "上传中file");
      console.log(fileList, "上传中fileList");
    },
    //上传成功
    successUpload() {
      let url = this.url + "/" + this.extraData.key;
      this.imageUrls.push(url);
      this.$emit("input", this.imageUrls); //通过this.$emit("input")父组件可以直接v-model绑定数据
      this.$message.success("上传成功");
    },

    //预览图片
    handlePictureCardPreview() {
      this.imageUrls = this.url + "/" + this.extraData.key;
      this.dialogVisible = true;
    },
    //移除图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    //上传图片的限制的提示
    exceed() {
      this.$alert(`您最多只能上传${this.limit}张图片`, {
        confirmButtonText: "确定",
        type: "warning",
      });
    },
    // deleteImage(ind) {
    //   console.log(ind)
    //   this.imageUrls.splice(ind, 1);
    // },
  },
};
</script>

<style scoped>
#bgsHover:hover {
  background: rgba(0, 0, 0, 0.5);
}
.item {
  margin-top: 10px;
  margin-right: 40px;
}
/deep/ .el-upload-dragger {
  position: relative;
  width: 80px !important;
  height: 80px !important;
  margin-top: 0;
}

/deep/ .child:first-child {
  margin-left: 20px;
}
</style>
